import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form','smokingNumber'];
  static classes = ['errorm','hide'];

  formTargetConnected() {
    this.toggleSmokingNumberInput();
  }

  checkboxDisable(event){
    const el = event.currentTarget;
    const selectors = document.getElementsByName(el.name);
    if(el.checked == true){
      selectors.forEach(function(s){
        s.checked = false;
        s.disabled = true;
      });
      el.checked = true;
      el.disabled = false;
    }else{
      selectors.forEach(function(s){
        s.disabled = false;
      });
    }
  }

  toggleSmokingNumberInput(){
    const form = this.formTarget;
    const smoking = form.querySelector("input[name='diagnostic[smoking]']:checked");
    if(smoking != undefined){
      if(smoking.value == "not"){
        this.smokingNumberTarget.classList.add(this.hideClass);
      }else{
        this.smokingNumberTarget.classList.remove(this.hideClass);
      }
    }
  }
}
